export const PAGE_PATH = '/create-withdraw-wallet';
